import React from 'react';
import Link from 'gatsby-link'
import Img from 'gatsby-image'


import styles from './Destinations.module.scss';

const Destinations = (props) => (
  <div className={styles.Destinations} id="destinations">
    <h2 className="h2">{props.title}</h2>
    <p className="p-large">{props.text}</p>
    <Link to={props.link.link} className="button">{props.link.text}</Link>

    <div className={styles.Cards}>
      {props.cards.map((card, i) =>
        <div className={styles.Card} key={i}>
          <Img sizes={card.featuredImage.sizes} alt={card.featuredImage.title} />
          <Link className="hoverlink" to={card.link.link}>{card.link.text}</Link>
        </div>
      )}
    </div>
  </div>
)

export default Destinations;



// WEBPACK FOOTER //
// ./src/components/Program/Destinations/index.js